import { ASSET_TYPES_BY_CATEGORY, AssetCategory, AssetType } from '../../lib/types';

/** Picker for "this feature/add-on produces what kind of asset?" — used
 *  by the partnership template editor and the per-campaign partnership
 *  editor so the "Generate draft assets" button later knows what to
 *  create. Grouped by category so the list stays scannable. */
export const AssetMappingPicker = ({
  type,
  grouping,
  onChange,
}: {
  type: string | undefined;
  grouping: 'shared' | 'per_brand' | undefined;
  onChange: (next: { produces_asset_type?: string; asset_grouping?: 'shared' | 'per_brand' }) => void;
}) => {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-4)' }}>
        Generates
      </span>
      <select
        className="input"
        value={type || ''}
        onChange={(e) => onChange({
          produces_asset_type: e.target.value || undefined,
          asset_grouping: e.target.value ? (grouping ?? 'shared') : undefined,
        })}
        style={{ fontSize: 12, padding: '4px 6px', maxWidth: 240 }}
      >
        <option value="">No placement — just a perk</option>
        {(Object.keys(ASSET_TYPES_BY_CATEGORY) as AssetCategory[]).map((cat) => (
          <optgroup key={cat} label={cat}>
            {ASSET_TYPES_BY_CATEGORY[cat].map((t: AssetType) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </optgroup>
        ))}
      </select>
      {type && (
        <>
          <span style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-4)' }}>
            ·
          </span>
          <select
            className="input"
            value={grouping || 'shared'}
            onChange={(e) => onChange({
              produces_asset_type: type,
              asset_grouping: e.target.value as 'shared' | 'per_brand',
            })}
            style={{ fontSize: 12, padding: '4px 6px' }}
            title="Shared = one asset, every matching brand linked. Per brand = one asset per brand."
          >
            <option value="shared">Shared across brands</option>
            <option value="per_brand">One per brand</option>
          </select>
        </>
      )}
    </div>
  );
};

export default AssetMappingPicker;
